import { gql } from "@apollo/client";

import { lensFragment } from "../../../shared/api/fragments";

export const getLensesForUpdate = gql`
    query getLensesForUpdate(
        $limit: Int!
        $offset: Int!
        $sortBy: SortBy!
        $sortDirection: MyLensesSortDirection!
        $filterBy: FilterBy
        $lensSpaceId: ID
        $type: GetLensesType!
    ) {
        lenses: getMyLensesLenses(
            input: {
                limit: $limit
                offset: $offset
                sortBy: $sortBy
                sortDirection: $sortDirection
                filterBy: $filterBy
                lensSpaceId: $lensSpaceId
                type: $type
            }
        ) {
            lensesList {
                ...Lens
                destinations {
                    id
                    lensId
                    destinationType
                    status
                }
            }
        }
    }
    ${lensFragment}
`;
